import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./arrow-down.svg?react";

export const ArrowDownIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
